// extracted by mini-css-extract-plugin
export default {"toggleContainer":"orXIe","toggleButton":"cPEpg","active":"V7_f5","toggleSlider":"aDDBX","darkMode":"Shkoo","disable":"i_Y6O"};